import { render, staticRenderFns } from "./RejectedApplicantsTable.vue?vue&type=template&id=24478301&scoped=true&"
import script from "./RejectedApplicantsTable.vue?vue&type=script&lang=ts&"
export * from "./RejectedApplicantsTable.vue?vue&type=script&lang=ts&"
import style0 from "./RejectedApplicantsTable.vue?vue&type=style&index=0&id=24478301&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24478301",
  null
  
)

export default component.exports